<agr-dialog [data]="data" (confirm)="confirm()" (alt)="alt()" (cancel)="cancel()">
  <p>{{ data.information }}</p>
  <div class="spacing--padding-bottom">
    <agr-extended-notification
      notificationType="{{ data.notificationType }}"
      [title]="data.notificationTitle"
      [message]="data.notificationMessage"
    >
    </agr-extended-notification>
  </div>
</agr-dialog>
